import Swiper from 'swiper'
import { FreeMode } from 'swiper/modules'

import { buildComponent } from '#components'

const AppComponent = buildComponent({
  name: 'app-component',
  onConnected: (component) => {
    const initSwiper = (carousel: HTMLElement) => {
      if (!carousel) return

      const carouselWrapper = carousel.querySelector('.instafeed-new-layout-wrapper')
      const carouselSlides = carousel.querySelectorAll('.instafeed-new-layout-item')

      if (carouselWrapper && carouselSlides && carouselSlides.length) {
        carousel.classList.add('swiper')
        carouselWrapper.classList.add('swiper-wrapper')
        carouselSlides.forEach((slide: Element) => slide.classList.add('swiper-slide'))

        new Swiper(carousel, {
          modules: [FreeMode],
          slidesPerView: 'auto',
          spaceBetween: 7,
          loop: true,
          breakpoints: {
            990: {
              spaceBetween: 17
            }
          }
        })
      }
    }
    const observer = new MutationObserver(() => {
      const instaFeedContainer = component.querySelector('#insta-feed .instafeed-new-layout-container') as HTMLElement

      if (instaFeedContainer) {
        initSwiper(instaFeedContainer)
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'app-component': typeof AppComponent
  }
}
